import { render, staticRenderFns } from "./GroupBookingPage.vue?vue&type=template&id=29fe1cdc&scoped=true&"
import script from "./GroupBookingPage.vue?vue&type=script&lang=js&"
export * from "./GroupBookingPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingPage.vue?vue&type=style&index=0&id=29fe1cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe1cdc",
  null
  
)

export default component.exports